import { render, staticRenderFns } from "./view-pick-list-serial.vue?vue&type=template&id=3809dd02&"
import script from "./view-pick-list-serial.vue?vue&type=script&lang=ts&"
export * from "./view-pick-list-serial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports